import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

export interface AuditoriaFiltros {
  limit?: number;
  offset?: number;
  es_critico?: boolean;
  tabla?: string;
  operacion?: string;
  usuario?: string;
  desde?: string;
  hasta?: string;
}

// Hook principal con filtros completos
export const useAuditoriaDashboard = (params?: AuditoriaFiltros) => {
  return useQuery({
    queryKey: ['auditoria', 'dashboard', params],
    queryFn: () => apiService.getAuditoriaDashboard(params),
    staleTime: 2 * 60 * 1000,
    retry: 2,
  });
};

// Hook para obtener historial de un registro específico
export const useAuditoriaHistorial = (tabla: string, id: string | number) => {
  return useQuery({
    queryKey: ['auditoria', 'historial', tabla, id],
    queryFn: () => apiService.getAuditoriaHistorial(tabla, id),
    enabled: !!tabla && !!id,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
};

// Hook para obtener estadísticas de auditoría
export const useAuditoriaEstadisticas = (periodo?: number) => {
  return useQuery({
    queryKey: ['auditoria', 'estadisticas', periodo],
    queryFn: () => apiService.getAuditoriaEstadisticas({ periodo }),
    staleTime: 10 * 60 * 1000,
    retry: 2,
  });
};

// Hook para obtener notificaciones de auditoría
export const useAuditoriaNotificaciones = (leida?: boolean) => {
  return useQuery({
    queryKey: ['auditoria', 'notificaciones', leida],
    queryFn: () => apiService.getAuditoriaNotificaciones({ leida }),
    staleTime: 1 * 60 * 1000,
    retry: 2,
  });
};
